import { SubscriptionState } from "./SubscriptionState.js";

export interface GetSubscriptionsResult {
    results: SubscriptionState[];
}
